import { TextInput } from '@mantine/core';
import { ChangeEvent } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { useEventContext } from 'Screens/Dashboard/Events/EventHandler/EntityEventContext';

const EventPlaceInput = () => {
    const intl = useIntl();
    const { values, updateValues } = useEventContext();
    const { eventPlace } = values;

    const updateEventPlace = (evt: ChangeEvent<HTMLInputElement>) => {
        updateValues({
            eventPlace: evt.target.value,
        });
    };

    return (
        <TextInput
            id="event-place-input"
            label={intl.formatMessage(messages.title)}
            placeholder={intl.formatMessage(messages.titlePlaceholder)}
            form="event-handler-form"
            type="text"
            maxLength={254}
            onChange={updateEventPlace}
            value={eventPlace}
            title={intl.formatMessage(messages.title)}
            radius="md"
            size="md"
        />
    );
};

const messages = defineMessages({
    title: {
        id: 'src.Screens.Dashboard.Events.EventHandler.inputs.EventPlaceInput.EventPlaceInput.title',
        defaultMessage: 'Miejsce',
    },
    titlePlaceholder: {
        id: 'src.Screens.Dashboard.Events.EventHandler.inputs.EventPlaceInput.EventPlaceInput.titlePlaceholder',
        defaultMessage: 'Wprowadź miejsce wydarzenia',
    },
});

export default EventPlaceInput;
